import type { Country } from '@kitopi-com/customer-auth';
import { getCountryFromTimeZone } from './getCountryFromTimeZone';
import { getSiteCountry } from './getSiteCountry';

interface GetDefaultCountryParams {
  supportedCountries: Country[];
  siteName: string | undefined;
  /** Overrides the browser time zone; intended for tests. */
  timeZone?: string;
}

/**
 * Picks the country to preselect in the phone-number picker without any network request:
 * the country of the UniFi site (from the captive-portal URL), then the country of the
 * browser time zone, then the first supported country.
 */
export const getDefaultCountry = ({
  supportedCountries,
  siteName,
  timeZone,
}: GetDefaultCountryParams): Country | undefined => {
  const candidates = [getSiteCountry(siteName), getCountryFromTimeZone(timeZone)];

  return (
    candidates.find((country): country is Country =>
      Boolean(country && supportedCountries.includes(country))
    ) ?? supportedCountries[0]
  );
};
